export default {
  affiliates: [],
}